import { Suspense } from 'react';
import { AppRouter } from './routes';
import { Loading } from './components/ui/Loading';

function App() {
  return (
    <Suspense fallback={<Loading full />}>
      <AppRouter />
    </Suspense>
  );
}

export default App;
